import React from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";

export default function CreateUserModal({
  show,
  title,
  creating,
  error,
  form,
  t,
  onClose,
  onChange,
  onSubmit
}) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || t("addUser")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>{t("name")}</Form.Label>
            <Form.Control
              name="name"
              value={form.name}
              onChange={onChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>{t("username")}</Form.Label>
            <Form.Control
              name="userName"
              value={form.userName}
              onChange={onChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={form.email}
              onChange={onChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>{t("address")}</Form.Label>
            <Form.Control
              name="address"
              value={form.address}
              onChange={onChange}
            />
          </Form.Group>
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onClose} className="me-2">
              {t("cancel")}
            </Button>
            <Button type="submit" variant="primary" disabled={creating}>
              {creating ? <Spinner size="sm" animation="border" /> : t("save")}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
